import { graphql } from 'gatsby';
import {
  StyledName,
  StyledAvatar,
  StyledTag,
  StyledImageElement,
  StyledAuthorInfo,
  StyledDetails,
} from './Author.styles';

export const AVATAR_IMAGE_HEIGHT = 48;
export const AVATAR_IMAGE_WIDTH = 48;

const Author = ({ authorElements }: Queries.AUTHORFragment) => {
  const { avatar, job_position, name } = authorElements;

  const authorName = name.value;
  const authorJob = job_position.value;
  const defaultAvatarDescription = `${authorName} photo`;
  const avatarDescription = avatar.value.description || defaultAvatarDescription;
  const image = {
    ...avatar.value,
    description: avatarDescription,
    height: avatar.value.height ?? AVATAR_IMAGE_HEIGHT,
    width: avatar.value.width ?? AVATAR_IMAGE_WIDTH,
  };

  return (
    <StyledAuthorInfo>
      <StyledAvatar>
        <StyledImageElement
          alt={avatarDescription}
          height={image.height}
          image={{ ...image, image_id: image.url }}
          width={image.width}
        />
      </StyledAvatar>
      <StyledDetails>
        <StyledName>{authorName}</StyledName>
        <StyledTag>{authorJob}</StyledTag>
      </StyledDetails>
    </StyledAuthorInfo>
  );
};

export const fragment = graphql`
  fragment AUTHOR on kontent_item_author {
    system {
      id
      type
    }
    authorElements: value {
      avatar {
        value {
          width
          url
          type
          height
          description
        }
      }
      job_position {
        value
      }
      name {
        value
      }
    }
  }
`;

export default Author;
